import { Component, OnInit, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { AppLoaderComponent } from './shared-components/app-loader/app-loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, AppLoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('diplomes');
  readonly showLoader = signal(true);

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => this.showLoader.set(false), 3300);
      });
  }
}
